import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

// Blocks rendering of protected routes until we've checked the session against the backend.
const RequireAuth = ({ children }) => {
  const { auth, loading, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked || loading) {
    return <LoadingSpinner message="Validando sesión..." size="lg" color="blue" />;
  }

  const authed = !!auth && Array.isArray(auth.permissions) && auth.permissions.length > 0;
  if (!authed) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
